<div class="action-list animate__animated animate__fadeInDown animate__faster">
    <div class="contenido">
        <h1>Previsualización</h1>

        <div class="pasos">
            <iframe id="ifrmPrevisualizar" src="" ></iframe>
        </div>
        <button mat-button class="btn-close"><img src="assets/icons/plus.png" (click)="close()"></button>
    </div>
</div>